SA.CrosstabHeaderCellMenu = class {
    static create({attribute, canRemoveAttribute, target}) {
        var items = [
            {
                html: SA.data.FavoriteAttributes.getToggleText(attribute),
                type: 'toggleFavorite'
            }, {
                html: 'View Metadata',
                type: 'viewMetadata'
            }, {
                html: 'Open Data Folder',
                type: 'openDataFolder'
            }
        ];

        if (canRemoveAttribute) {
            items.push({
                html: 'Remove from this Report',
                type: 'remove'
            });
        }

        return new SA.ArrowMenu2({caption: SA.data.AttributesCache.getLabel(attribute), items, placement: 'right', target});
    }
};